import React, { useCallback } from 'react';
import { useNavigate } from 'react-router-dom';
import { Logout02Icon, UserStatusIcon } from 'hugeicons-react';
import { useAuth } from '../../contexts/AuthContext';
import { useChatContext } from '../../contexts/AppDataContext';
import { UserAvatar } from './MiniDisplays/UserAvatar';
import { useWindow } from '../../contexts/WindowContext';
import {
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuRow,
  DropdownMenuSeparator,
  DropdownMenuTrigger,
} from '../ui/dropdown-menu';

export const UserDropdown: React.FC = React.memo(() => {
    const auth = useAuth();
    const navigate = useNavigate();
    const { setMessages, setShowSalesModal } = useChatContext();
    const { windowWidth, logoImage } = useWindow();

    const handleHelpClick = useCallback((): void => {
      window.open('https://cognora.ca/faq', '_blank');
    }, []);

    const handleLogoutClick = useCallback((): void => {
      auth.logout();
      navigate('/');
      setMessages([]);
    }, [auth, navigate, setMessages]);

    const handleSettingsClick = useCallback((): void => {
      navigate('/settings/profile');
    }, [navigate]);

    const handleUpgradeClick = useCallback((): void => {
      setShowSalesModal(true);
    }, [setShowSalesModal]);

    const handleTOSClick = useCallback((): void => {
      window.open('https://cognora.ca/terms-of-service', '_blank');
    }, []);
  
    if (windowWidth < 600 || !auth.user) {
      return null;
    }

    return (
      <DropdownMenu>
        <DropdownMenuTrigger asChild>
          <button 
            className="settings-button"
            aria-label="Open user menu"
          >
            <UserAvatar />
          </button>
        </DropdownMenuTrigger>
        <DropdownMenuContent align="start" sideOffset={8}>
          <DropdownMenuRow
            icon={<UserStatusIcon />}
            text={auth.user.email}
            action={handleSettingsClick}
          />

          <DropdownMenuRow text="Settings" action={handleSettingsClick} />

          {auth.subscription?.plan !== 'ultimate' && (
            <DropdownMenuRow
              icon={<img src={logoImage} alt="" />}
              text="Upgrade Plan"
              action={handleUpgradeClick}
            />
          )}

          <DropdownMenuRow text="Help" action={handleHelpClick} />

          <DropdownMenuRow text="Terms of Service" action={handleTOSClick} />

          <DropdownMenuSeparator />

          <DropdownMenuRow
            icon={<Logout02Icon />}
            text="Logout"
            action={handleLogoutClick}
          />
        </DropdownMenuContent>
      </DropdownMenu>
    );
  });
